import BodilyInjury from './BodilyInjury';
export default BodilyInjury;
